import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRight from '@material-ui/icons/ArrowRightAlt'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useNavigate } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import $ from "jquery";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {

        marginLeft: 240,
    },
    drawer: {
        width: '100%',
        flexShrink: 0,
    },
    drawerPaper: {
        width: 100,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: "none !important",
        border: "1px solid #F1F1F1",

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
}));

const SidebarAddProject = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isMobile, setisMobile] = React.useState();
    const [value, setValue] = React.useState(0);
    const [more, setMore] = React.useState(true);
    const [less, setLess] = React.useState(true);
    const [plan, setPlan] = React.useState(true);
    const [add, setAdd] = React.useState(true);
    const navigate = useNavigate();
    const ProjectNavigation = (e, str) => {
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("spanTopBar");
        e === 1 ? navigate("/basicinformation/add") :
            e === 2 ? navigate("/incharge/add") :
                e === 3 ? navigate("/shipparticulars/add") :
                    e === 4 ? navigate("/introduction/add") :
                        e === 5 ? navigate("/process/add") :
                            e === 6 ? navigate("/settings/add") :
                                e === 7 ? navigate("/historylog") : navigate("")
    };

    // const EditNavigation = (e, str) => {
    //     $(".naviIcon").removeClass("d-block");
    //     $(".naviIcon").addClass("d-none");
    //     $("#" + str).removeClass("d-none");
    //     $("#" + str).addClass("d-block");
    //     $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
    //     $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
    //     e === 1 ? navigate("/basicinformation/edit") :
    //         e === 2 ? navigate("/incharge/edit") :
    //             e === 3 ? navigate("/shipparticulars/edit") :
    //                 e === 4 ? navigate("/introduction/edit") :
    //                     e === 5 ? navigate("/process/edit") :
    //                         e === 6 ? navigate("/settings/edit") :
    //                             e === 7 ? navigate("historylog") : navigate("")
    // };
    useEffect(() => {
        window.addEventListener('resize', resize);
        const interval = setInterval(() => {
            resize()
        }, 100);
        return () => clearInterval(interval);
    }, []);

    const resize = () => {
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
        $("#Add1 .MuiListItemText-primary").addClass("spanTopBar");
    };

    return (
        <>
            {isMobile ?
                <div className={classes.root}>
                    <CssBaseline />
                    <List className="pt-4 mt-5 w-100 " style={{ backgroundColor: "#F6F6F6", width: 240, height: "calc(100vh)", bottom: 0 }} >
                        <ListItem className='border-bottom' >
                            <ListItemText id={"Add" + "1"} className='pl-3 textNaviIcon' primary="New Project" />
                            <NavigateBeforeIcon id="Add" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        {['Basic Information', 'In Charge', 'Ship Particulars', 'Introduction', 'Process', 'Settings'].map((text, index) => (
                            <ListItem className="" button key={text} onClick={() => { ProjectNavigation(index + 1, text.replaceAll(" ", "")) }}>
                                <ListItemText className="px-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                            </ListItem>
                        ))}
                    </List>
                </div>
                : navigate('/basicinformation/add')
            }
        </>
    )
}
export default SidebarAddProject;